import styled from 'styled-components';
import { DisplayBox } from '@m/alchemy-ui/DisplayBox';
import { color, units } from '@m/alchemy-ui/theme';

export const AreaOfExcellenceContainer = styled(DisplayBox)<{
  checked: boolean;
  disabled: boolean;
}>`
  border: none;
  background: ${props => {
    if (props.checked)
      return color('highlight', { palette: 'interactiveConstructive' });
    if (props.disabled) return '#ffffff';

    return '#f8f9fa';
  }};
  margin: 10px 0;
  padding: ${units(1)} ${units(2)};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
`;
